

module.exports = __webpack_require__.stylable.create(
    "Groups3400290406",
    {"classes":{"root":"Groups3400290406__root","header":"Groups3400290406__header","title":"Groups3400290406__title","createNewButton":"Groups3400290406__createNewButton"},"vars":{},"stVars":{},"keyframes":{"fadeout":"Groups3400290406__fadeout"}},
    "",
    12,
    "Groups3400290406",
    null
);
